import type { Props } from "~/components/ui/ResponsiveImage"
import { bannerAspect } from "~/components/ui/ResponsiveImage"
export { default } from "~/components/ui/ResponsiveImage"

// Mesmo motivo do `Images/Carousel.tsx`: a primeira instância desta section na
// home é EAGER (as de baixo entram por `data-deferred`, que respeita o
// `LoadingFallback`). Sem `sync` a eager cai no `<Suspense fallback={null}>` e
// o banner do topo ocupa 0px até o fim do stream — o `unsized-images` da home.
export const sync = true

export function LoadingFallback({ desktop, mobile }: Partial<Props>) {
  // Reserve real banner height to prevent CLS. Aqui o chute de fileta 10:1 é
  // aceitável (não há imagem para cropar, só uma caixa cinza); no componente
  // final ele NÃO é — vira crop no CDN. Ver `bannerAspect`.
  const w = desktop?.width ?? mobile?.width ?? 1920
  const h = Math.round(w * (bannerAspect(desktop, mobile) ?? 0.1))
  return (
    <div
      className='w-full bg-base-200/30 animate-pulse'
      style={{ aspectRatio: `${w} / ${h}` }}
    />
  )
}
